import { EmployeeProperties } from "./employee.type";
import { ListingPropertyTypeProperties } from "./listingPropertyType.type";
import { OfficeProperties } from "./office.type";
import { ProfileProperties } from "./profile.type";
import { UserProperties } from "./user.type";

export enum EExchangeBoardType {
	FOR_SALE = "FOR_SALE",
	FOR_RENT = "FOR_RENT",
	WTB = "WTB",
	WTR = "WTR",
}
export interface ExchangeBoardProperties {
	exchangeBoardId: string;
	title: string;
	titlePlainText?: string;
	type: EExchangeBoardType;
	city: string;
	cityGroupId?: string;
	location?: string;
	landSize: number;
	buildingSize: number;
	budget: number;
	listingPropertyTypeId?: string;
	isPublished: boolean;
	picUserId: string;
	picEmployeeId: string;
	picOfficeId?: string;
	createdByUserId: string;
	createdByUserMeta: any;
	updatedAt: Date;
	createdAt: Date;
	expiredAt?: Date;
	isExpired: boolean;

	listingPropertyType?: ListingPropertyTypeProperties;
	picUser?: UserProperties;
	picEmployee?: EmployeeProperties;
	picProfile?: ProfileProperties;
	picOffice?: OfficeProperties;
}
export type CreateExchangeBoardDto = Omit<
	ExchangeBoardProperties,
	| "exchangeBoardId"
	| "createdByUserId"
	| "createdByUserMeta"
	| "updatedAt"
	| "createdAt"
	| "expiredAt"
	| "isExpired"
	| "listingPropertyType"
	| "picUser"
	| "picEmployee"
	| "picProfile"
	| "picOffice"
>;
export interface ListExchangeBoardQuery {
	filterCreatedByUserId?: string;
	filterIsPublished?: string;
	includeData?: string;
	sort?: string;
	filterCity?: string;
	filterCityGroupId?: string;
	filterType?: string;
	filterBudgetMin?: number;
	filterBudgetMax?: number;
	filterListingPropertyTypeId?: string;
}

export interface ExchangeBoardCityResponse {
	cities: string[];
}
